import { Form } from './form';

class FormBuilderForm extends Form {
  getString(key) {
    const id = this.form.getAttribute('id');
    const settings = window[id];
    if (settings && settings.strings && settings.strings[key]) {
      return settings.strings[key];
    }

    return key;
  }

  handleSuccess() {
    if (this.propagateGtm) {
      this.propagateGtmEvent();
    }

    const successText = this.getString('success_message');
    const message = `<div class="note note--success">
        <p>${successText}</p>
      </div>`;

    this.showSuccessMessage(message);
  }
}

export default () => {
  const formBuilderElements = [...document.querySelectorAll('.js-form-builder-form')];

  formBuilderElements.forEach((formEl) => {
    new FormBuilderForm(formEl);
  });
};
